import http from "./http";

const toForm = (params) => {
  const fd = new FormData();
  Object.entries(params).forEach(([k, v]) => fd.append(k, v ?? ""));
  return fd;
};

/* GET all notifications — optional { from, to } date filters */
export const getNotifications = async (filters = {}) => {
  const params = new URLSearchParams({ action: "get", ...filters }).toString();
  const res = await http.get(`notifications.php?${params}`);
  return res.data;
};

/* ADD a new notification */
export const addNotification = async ({ title, short_description, onclick_link = "", is_active = 1 }) => {
  const res = await http.post(
    "notifications.php?action=add",
    toForm({ title, short_description, onclick_link, is_active })
  );
  return res.data;
};

/* UPDATE an existing notification */
export const updateNotification = async ({ id, title, short_description, onclick_link = "", is_active }) => {
  const res = await http.post(
    "notifications.php?action=update",
    toForm({ id, title, short_description, onclick_link, is_active })
  );
  return res.data;
};

/* TOGGLE active/inactive */
export const toggleNotification = async (id) => {
  const res = await http.post("notifications.php?action=toggle", toForm({ id }));
  return res.data;
};

/* DELETE a notification */
export const deleteNotification = async (id) => {
  const res = await http.post("notifications.php?action=delete", toForm({ id }));
  return res.data;
};
